import s3_bg from '../../../assets/images/s3_bg.png';
import right_arrow_white from '../../../assets/images/right_arrow_white.png';

export default function Section4() {
  return (
    <>
      <div className="sect4 pt-7">
        <div className="s4_content mb-4">
          <div className="txt-center ">
            <p className="prt-medium fs-20 fc-005eed mb-1" >Product Video</p>
            <p className="prt-bold fs-50 fc-black1 lh-13">주요기능영상</p>
          </div>
        </div>

        <div className="w-100 youtube relative">
          <iframe
            className="w-100"
            src="https://www.youtube.com/embed/FfIQfC8Z_nE?autoplay=1&mute=1"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; 
            encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>

          {/* <div className="youtube-text">
            <div className="youtube-title">글로벌 자율주행</div>
            <div className="youtube-subtitle">배송로봇 선도기업</div>
          </div>

          <div className="c30_viewmore">자세히보기</div> */}
        </div>
      </div>
    </>
  );
}
